var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { cn } from 'hx-util';
export function ContentCard(_a) {
    var children = _a.children, icon = _a.icon, header = _a.header, button = _a.button, className = _a.className, _b = _a.isGradient, isGradient = _b === void 0 ? false : _b;
    if (header) {
        return (_jsxs("div", __assign({ className: cn('mx-8 p-4 rounded-3xl md:mx-auto md:w-full max-w-2xl bg-gray shadow-[0px_1px_6px_2px_rgba(0,0,0,0.25)] flex-col flex space-y-3', className) }, { children: [_jsxs("div", __assign({ className: 'flex flex-col space-y-2 md:flex-row items-center md:items-start justify-center md:space-x-4' }, { children: [!!icon && (_jsx("div", __assign({ className: 'mx-auto max-w-8 md:max-w-12 md:pt-2' }, { children: _jsx("img", { src: icon.src, alt: icon.alt, className: 'mx-auto w-8 md:w-10' }) }))), _jsx(Typography, __assign({ className: 'text-xl leading-relaxed font-extrabold text-primary text-center inline-block w-full' }, { children: header }))] })), children, button] })));
    }
    if (children) {
        return (_jsx("div", __assign({ className: cn('mx-8 p-1 rounded-3xl overflow-hidden shadow-[1px_1px_15px_5px_rgba(0,0,0,0.10)] md:w-full max-w-2xl md:mx-auto bg-primary', {
                'bg-[linear-gradient(to_right,#719BFF,#80D6D0_25%,#CD95DF_50%,#FB9C84_70%)]': isGradient,
            }, className) }, { children: _jsx("div", __assign({ className: 'px-5 py-4 rounded-[20px] bg-white w-full h-full ring ring-white' }, { children: children })) })));
    }
    return null;
}
